import createCache from '@emotion/cache';
import { DECLARATION, prefixer } from 'stylis';

// Every browser the site supports reads the rest unprefixed; Safari still needs -webkit- for these.
const SAFARI_PREFIXED = new Set(['user-select', 'backdrop-filter', 'background-clip', 'mask-image']);

const prefixForSafari = (element, index, children, callback) =>
    element.type === DECLARATION && SAFARI_PREFIXED.has(element.props)
        ? prefixer(element, index, children, callback)
        : undefined;

export const createEmotionCache = () => createCache({ key: 'css', stylisPlugins: [prefixForSafari] });
